var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": _vm.color
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [(_vm.canReadPerson || _vm.canReadCompany) && _vm.hasRef ? _c('v-list-item-title', {
    staticClass: "text-truncate",
    on: {
      "click": function click($event) {
        return _vm.goToParty(_vm.invoiceParty);
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.invoiceParty.name))])]) : _c('v-list-item-title', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.invoiceParty.name) + " ")]), _vm.invoiceParty.address && !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.invoiceParty.address.street) + ", " + _vm._s(_vm.invoiceParty.address.zip) + " " + _vm._s(_vm.invoiceParty.address.city) + " ")]) : _vm._e(), !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.invoiceParty.email) + " ")]) : _vm._e(), !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.invoiceParty.phone) + " ")]) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }